import React, { useContext } from 'react';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import { Button } from '@/shared/components/Button';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../context/AuthContext';

const CurrecnyUploadSheet = ({ setCurrencyRefresh }) => {
  const { apiGlobal } = useContext(AuthContext);


  const handleSubmit = async (event) => {
    event.preventDefault();
    const fileInput = document.getElementById('currency-upload');
    const file = fileInput.files[0];
    const formData = new FormData();
    formData.append('excel', file);


    try {
         const url = await fetch(`${apiGlobal}/country_currency_update_excel.php`, {
          method: 'post',
          body: formData,
         });
          const response = await url.json();
          if (response.status) {
            setCurrencyRefresh(prev => !prev);
            toast.success('File uploaded successfully');
          } else {
            toast.error('Error uploading file');
            console.error('Error uploading file:', response.message);
          }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
  };

  return (
    <Col>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>
              Upload Currency Excel Sheet
            </CardTitle>
          </CardTitleWrap>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <input
                  type="file"
                  accept=".csv"
                  className="form-control"
                  id="currency-upload"
                  name="currency-upload" 
                  required
                />
              </Col>
              <Col md={6}>
                <Button
                  type="submit"
                  variant="outline-danger"
                  size="sm"
                  className="btn btn-primary"
                >
                  Upload
                </Button>
            
                <Button
                  type="button"
                  variant="outline-danger"
                  size="sm"
                  className="btn btn-primary"
                >
                  Fetch From API
                </Button>
              </Col>
            </Row>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
}; 

CurrecnyUploadSheet.propTypes = {
  setCurrencyRefresh: PropTypes.func.isRequired,
};


export default CurrecnyUploadSheet;
